import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import CONFIG from "../src/config"; // Import the config file
import axios from "axios";

import { useLocation } from "react-router-dom";

const BoardofDirectors = () => {
  const location = useLocation(); // Get the current location (path)
  // Base URL of the site
  const meta = metaConfig.directorsboard;

  const [bioData, setBioData] = useState([]);

  useEffect(() => {
    // Fetch data from the backend
    axios
      .get(`${CONFIG.BASE_URL}/biodata/get/all`) // Replace with your API URL
      .then((response) => {
        setBioData(response.data); // Assuming response data is an array of blog objects
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  }, []);

  return (
    <div>
      <SEO {...meta} />
      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
            <!-- Header Start --> */}
      <div class="container-fluid boardmember_bread bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Community and Family Ties
          </h4>
        </div>
      </div>
      {/* <!-- Header End -->

            <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      <div className="container-fluid innercontain team boardmbers_inn overflow-hidden py-5">
        <div className="container">
          <div
            className="text-center mx-auto pb-3 wow fadeInUp"
            data-wow-delay="0.2s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-3 text-white  text-capitalize mb-3">
              KTIG BOARD OF MEMBERS
            </h1>
          </div>

          <div className="row mt-3 mp-0 pb-5 g-4">
            {bioData.map((item, index) => (
              <div className="col-md-3 boardlist_inner mt-0 col-lg-3">
                <div
                  className="col-md-12 mt-0 col-lg-12 boardlist p-0 wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="team-item p-4">
                    <Link
                      to="/board-of-directories-details"
                      state={{
                        memberName: item.memberName,
                        organizationName: item.organizationName,
                        imageUrl: `${item.imagePath}`,
                        designation: item.designation,
                        energyTitle: item.energyTitle,
                        energySubTitle: item.energySubTitle,
                        energyDescription: item.energyDescription,
                        encourageTitle: item.encourageTitle,
                        encourageSubTitle: item.encourageSubTitle,
                        encourageDescription: item.encourageDescription,
                        engagedTitle: item.engagedTitle,
                        engagedSubTitle: item.engagedSubTitle,
                        engagedDescription: item.engagedDescription,
                      }}
                      className="text-decoration-none"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div className="team-inner rounded">
                        <div className="team-img">
                          <img
                            src={`${item.imagePath}`}
                            className="img-fluid rounded-top w-100"
                            alt="Director"
                          />
                        </div>
                        <div className="teamcontent rounded-bottom text-center py-4">
                          <h6 className="mb-3">{item.memberName}</h6>
                          <p className="mb-0">{item.designation}</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />

      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default BoardofDirectors;
